/**
 * The assistant's entry point in the CRM subheader, and the only thing the 11 call sites import.
 *
 * It renders `AssistantDrawer` for holders of `CRM_ASSISTANT` and nothing at all for everyone else —
 * no button, no fallback — see `assistantAccess`. The check sits here, before the drawer mounts, so
 * a user without the permission never sends the drawer's opening requests either.
 *
 * Takes `({ className, style })` and passes them through, which is why the gate can live here
 * instead of at every call site.
 */
import React from "react";
import { useSelector } from "react-redux";
import AssistantDrawer from "./AssistantDrawer";
import { canAskAssistant } from "./assistantAccess";

const ChatGptDrawer = (props) => {
    const user = useSelector((state) => state.auth.user);
    return canAskAssistant(user) ? <AssistantDrawer {...props} /> : null;
};

export default ChatGptDrawer;
